"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const contactBlockInputs = [
  {
    name: "layout",
    type: "string",
    enum: ["horizontal", "vertical"],
    defaultValue: "horizontal",
    required: true,
  },
  {
    name: "contactBlocks",
    type: "list",
    required: true,
    subFields: [
      {
        name: "contactType",
        enum: ["Phone", "Mail", "Account", "Info", "Live Chat"],
        defaultValue: "Phone",
        required: true,
        type: "string",
      },
      {
        name: "ctaLink",
        type: "url",
        defaultValue: "tel:800876659",
        required: true,
      },
      {
        name: "info",
        type: "string",
        defaultValue: "800 808 000",
        required: true,
      },
      {
        name: "additionalInfo",
        type: "string",
        defaultValue: "Monday to Friday: 8am to 10pm and Weekends: 10am to 6pm.",
      },
    ],
    defaultValue: [
      {
        contactType: "Phone",
        ctaLink: "tel:800808000",
        info: "0800 808 000",
        additionalInfo: "Monday to Friday: 8am to 10pm and Weekends: 10am to 6pm.",
      },
      {
        contactType: "Mail",
        ctaLink: "/",
        info: "Write to us",
        additionalInfo: "Some email",
      },
    ],
  },
] as const satisfies Inputs;

export const ContactBlockComponent: RegisteredComponent = {
  name: "ContactBlock",
  component: withValidation(
    contactBlockInputs,
    dynamic(() => import("./ContactBlock").then((mod) => mod.ContactBlock)),
    "ContactBlock"
  ),
  inputs: contactBlockInputs,
};
